module.exports = __webpack_public_path__ + "media/images/landing/icon-stars-b54a58f73ca83cde64d5e1a2e10840a1.svg";